import { images } from "../../constants";
 
const stacksData = [
  {id: 1, title:'Figma',  imgUrl: images.figma},
  {id: 2, title:'Flutter',  imgUrl: images.flutter},
  {id: 1, title:'Git',  imgUrl: images.git},
  {id: 1, title:'NodeJS',  imgUrl: images.node},
  {id: 1, title:'ReactJS',  imgUrl: images.react},
  {id: 1, title:'Java',  imgUrl: images.Java},
  {id: 1, title:'Python',  imgUrl: images.python},
  {id: 1, title:'VueJS',  imgUrl: images.vue},
  {id: 1, title:'Ethereum',  imgUrl: images.Ethereum},
  {id: 1, title:'Solidity',  imgUrl: images.Solidity},
  // {id: 1, title:'Typescript',  imgUrl: images.typescript},
  // {id: 1, title:'Redux',  imgUrl: images.redux},
  // {id: 1, title:'Sass',  imgUrl: images.sass},
  // {id: 1, title:'HTML',  imgUrl: images.html},
  // {id: 1, title:'GraphQl',  imgUrl: images.graphql},
  // {id: 1, title:'CSS',  imgUrl: images.css},
  // {id: 1, title:'API',  imgUrl: images.api},
  ]
  export default stacksData;
  